import React, { ReactElement } from "react";
import { Table } from "antd";
import { UnfulfilledDirectoryOver20HoursRecord } from "../../../redux/types/reportTypes";

export const columns = [
  {
    title: "Publisher",
    dataIndex: "publisher",
  },
  {
    title: "Cluster Id",
    dataIndex: "cluster_id",
  },
  {
    title: "Ad Uuid",
    dataIndex: "ad_uuid",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
  },
  {
    title: "Start Date",
    dataIndex: "start_date",
  },
  {
    title: "End Date",
    dataIndex: "end_date",
  },
  {
    title: "State",
    dataIndex: "state",
  },
];

type UnfulfilledDirectoryOver20HoursProps = {
  loading: boolean;
  records: Array<UnfulfilledDirectoryOver20HoursRecord>;
};

const UnfulfilledDirectoryOver20HoursTable = ({ loading, records }: UnfulfilledDirectoryOver20HoursProps): ReactElement => (
  <Table
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="publisher"
    pagination={false}
    scroll={{ y: 350, x: 3200 }}
  />
);

export default UnfulfilledDirectoryOver20HoursTable;
